import { render, staticRenderFns } from "./wh7.vue?vue&type=template&id=120c224e&scoped=true&"
import script from "./wh7.vue?vue&type=script&lang=js&"
export * from "./wh7.vue?vue&type=script&lang=js&"
import style0 from "./wh7.vue?vue&type=style&index=0&id=120c224e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120c224e",
  null
  
)

export default component.exports